<div class="op-dialog">

  <div class="op-header">
    <h2 class="op-title">
      <mat-icon>trending_down</mat-icon>
      Operación de Salida
    </h2>
    <div class="op-header-actions">
      <mat-button-toggle-group *ngIf="isBroker" class="op-seg" name="livesincro" aria-label="Modo de la operación"
          [(ngModel)]="sincro" (change)="onCambioSincro()" hideSingleSelectionIndicator>
        <mat-button-toggle [value]="false" class="seg-live" matTooltip="Envía la orden al broker">
          <span class="live-dot"></span>Live
        </mat-button-toggle>
        <mat-button-toggle [value]="true" class="seg-sincro" matTooltip="Solo registra la operación (sin orden al broker)">
          <mat-icon>sync</mat-icon>Sincro
        </mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-icon-button class="close-button" mat-dialog-close aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="op-content">

    <app-cotizacion-fuente
        [wallet]="optimaWallCartera" [isBroker]="isBroker" [(stkcfd)]="stkcfd" [tipoEditable]="isBroker"
        [idNectum]="compania.idNectum" [symbol]="symbol" [conid]="compania.conid"
        [fecha]="compania.fechaCotizacion" [decimales]="decimales"
        (precio)="onPrecio($event)" (sinDatos)="isHabil = $event"
        (contrato)="compania.currency = $event.currency; compania.listingExchange = $event.listingExchange">
    </app-cotizacion-fuente>

    <!-- Compañía -->
    <div class="section-header section-header--inline mt-3">
      <mat-icon class="small-icon">business</mat-icon>
      <span>Compañía</span>
      <input type="text" class="dense-input compania-input" placeholder="ex. AAPL" aria-label="Compañía"
          [formControl]="myControl" [matAutocomplete]="auto" (focus)="$any($event.target).select()">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selected($event)">
        <cdk-virtual-scroll-viewport itemSize="10" style="height: 223px; width: 100%;">
          <mat-option *cdkVirtualFor="let option of filteredOptions | async" [value]="option.nombreCompania">
            <strong>{{ option.nombreCompania }}</strong>
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
      <span class="entrada-badge ms-auto" [class.bajista]="compania.bajista" [class.alcista]="!compania.bajista">
        {{ compania.bajista ? 'Entrada Bajista' : 'Entrada Alcista' }}
      </span>
    </div>

    <!-- Orden (solo Broker Live) -->
    <ng-container *ngIf="!sincro && isBroker">
      <div class="section-header mt-3">
        <mat-icon class="small-icon">receipt_long</mat-icon>
        <span>Orden</span>
      </div>

      <div class="fields-grid">
        <label class="field-label">Tipo Orden</label>
        <select class="dense-input"
            [(ngModel)]="ordersData.orders[0].orderType"
            name="orderType" aria-label="Tipo de orden"
            (ngModelChange)="activarPrecioOrden()">
          <option value="{{type.value}}" *ngFor="let type of orderType">{{type.type}}</option>
        </select>

        <ng-container *ngIf="activateedPrecioOrden">
          <label class="field-label">Precio Orden</label>
          <input type="number" class="dense-input" [(ngModel)]="ordersData.orders[0].price"
              (ngModelChange)="activarPrecioOrden()" step="0.01">

          <label class="field-label">Porcentaje</label>
          <input type="number" class="dense-input" [(ngModel)]="porcentaje"
              (ngModelChange)="activarPrecioOrden()" step="0.01">
        </ng-container>
      </div>
    </ng-container>

    <!-- Parámetros -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">analytics</mat-icon>
      <span>Parámetros</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Cotización</label>
      <input type="number" class="dense-input" [ngModel]="compania.cotizacion"
          (ngModelChange)="calculoRetorno($event)" step="0.01">

      <label class="field-label">Precio Entrada</label>
      <input type="number" class="dense-input" [ngModel]="compania.precioentradareal" step="0.01" [disabled]="true">

      <label class="field-label">Coste</label>
      <input type="number" class="dense-input" [ngModel]="compania.costeoperacion" step="0.01" [disabled]="true">

      <label class="field-label">Retorno</label>
      <input type="number" class="dense-input" [ngModel]="retorno" step="0.01" [disabled]="true">
    </div>

    <!-- Fecha (en Broker Live siempre hoy) -->
    <div class="section-header mt-3">
      <mat-icon class="small-icon">calendar_today</mat-icon>
      <span>Fecha</span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Fecha</label>
      <input type="date" class="dense-input" [(ngModel)]="compania.fechaCotizacion"
          [disabled]="isBroker && !sincro">
    </div>

    <div *ngIf="isHabil" class="alert-no-numbers">
      Fecha sin data de cotización en ninguna fuente.
    </div>

    <div *ngIf="avisoMercadoCerrado" class="alert-no-numbers">
      Mercado cerrado: la orden puede ser rechazada o ejecutarse en la próxima apertura.
    </div>

  </div>

  <div class="op-actions">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>
    <button mat-flat-button color="primary" [disabled]="isHabil || enviando" (click)="guardarOpeSalida()">
      {{ enviando ? 'Enviando…' : 'Aceptar' }}
    </button>
  </div>

</div>
